import React, {useEffect, useState} from 'react'
import {useNavigate} from 'react-router-dom'
import styles from './styles.module.scss'
import {Button, ButtonLink, Flex, Link, Slider} from '@sbab-ui/components'
import {NumericFormat} from "react-number-format";
import {CheckList, ResultCallout} from '../../components'
import {calculateMonthsToReachGoal, getSecureWebDomain,} from '../../utils/util'


const Result = ({ sum }) => {
  const [monthlySavings, setMonthlySavings] = useState(2000)
  const [monthsGoal, setMonthsGoal] = useState(0)
  const navigate = useNavigate()

  useEffect(() => {
    setMonthsGoal(calculateMonthsToReachGoal(sum, monthlySavings))
  }, [sum, monthlySavings, setMonthsGoal])

  const updateMonthlySavings = value => {
    setMonthlySavings(value)
    setMonthsGoal(calculateMonthsToReachGoal(sum, value))
  }

  const monthlySavingsText = (
    <>
      <span>För att nå ditt mål behöver du spara </span>
      <nobr>
        <span style={{ color: 'black' }}>
          <NumericFormat
            value={monthlySavings}
            thousandSeparator=' '
            displayType='text'
          />{' '}
          kr{' '}
        </span>
      </nobr>
      {monthsGoal > 1 && ' per månad '}
      <nobr>
        i{' '}
        <span style={{ color: 'black' }}>
          {monthsGoal === 1 ? 'en månad' : `${monthsGoal} månader`}.
        </span>
      </nobr>
    </>
  )

  return (
      <Flex direction="column" gap="3rem">
      <ResultCallout result={sum} />
      <section>
          <div className={styles.checklistLabel}>På ett sparkonto hos SBAB har du alltid</div>
        <div className={styles.checkList}>
          <CheckList>
              <span>Fria uttag, inga avgifter</span>
              <span>Ränta från första kronan</span>
              <span>Pengarna tryggade med{' '}
              <Link
                href='https://www.sbab.se/1/sidfotsmeny_2/insattningsgarantin.html'
                external
              >
                insättningsgaranti
              </Link>
            </span>
          </CheckList>
        </div>
        {new URLSearchParams(window.location.search).get('client-channel') ===
        'app' ? null : (
          <div className={styles.buttonContainer}>
              <Button variant='secondary'
                      onClick={() => {
                          navigate('../')
                      }}>
                  Tillbaka
              </Button>
              <ButtonLink variant='primary' className={styles.buttonLink} external
                          href={`https://${getSecureWebDomain()}.sbab.se/logga-in?dep=privat&redirect=${encodeURIComponent(
                              '/sparkonto/oppna?referredBy=buffercalc'
                          )}`}>
                  Öppna sparkonto för din buffert
              </ButtonLink>
          </div>
        )}
      </section>
      <section>
        <p>
          Testa hur mycket du behöver spara per månad och hur det påverkar tiden
          det tar att spara ihop till din buffert.
        </p>
          <div>
          <Slider
              className={styles.slider}
              aria-label="Spara per månad"
              label="Hur mycket vill du spara per månad?"
              value={monthlySavings}
              onChange={updateMonthlySavings}
              showOutput
              min={100}
              max={ Math.max(sum / 10, 15000)}
              step={100}
              formatOptions={{
                  style: 'currency',
                  currency: 'SEK',
              }}
          />
        </div>
        <p className='secondary'>{monthlySavingsText}</p>
      </section>
      </Flex>
  )
}

export { Result }
